import {
  stepTestNameFromMetaRelPath,
  isStepTestMetaRelPath,
} from "../../shared/stepTests/constants";

export type StepTestFixtureSetupRequest = {
  stepDir: string;
  executionId: string;
};

export function pinnedByExecutionId(
  files: readonly { path: string; content: string }[]
): Map<string, string> {
  const map = new Map<string, string>();
  for (const f of files) {
    if (isStepTestMetaRelPath(f.path)) {
      const name = stepTestNameFromMetaRelPath(f.path);
      const executionId = f.content.trim();
      if (executionId) map.set(executionId, name);
    }
  }
  return map;
}
